var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgKelpIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kelp-icon 1",
    clipPath: "url(#clip0_15840_96400)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.93697 0.0241318L4.37721 0.897412C3.81341 1.21307 3.76325 1.99793 4.28237 2.38137L5.87494 3.55766C6.19928 3.79725 6.16804 4.28762 5.81587 4.48504L4.37876 5.29038C3.81462 5.60654 3.76529 6.39229 4.28554 6.77512L5.80177 7.89083C5.95911 8.00658 6.05183 8.18917 6.05183 8.38317V8.42912C6.05183 8.57033 6.20593 8.65896 6.32993 8.589L7.89789 7.70463C8.46198 7.38646 8.50821 6.59904 7.98513 6.21833L6.39372 5.06012C6.06699 4.82233 6.09562 4.3305 6.44779 4.13144L7.90076 3.31006C8.46396 2.99167 8.51006 2.20524 7.98779 1.82457L6.46686 0.716012C6.30825 0.600375 6.21457 0.416996 6.21457 0.222007V0.184332C6.21457 0.0433541 6.06097 -0.0452888 5.93697 0.0241318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.51511 1.41085L0.955335 2.28413C0.391534 2.59979 0.341372 3.38465 0.860493 3.76808L2.45305 4.94437C2.77742 5.18395 2.74619 5.67437 2.39397 5.87175L0.956884 6.67712C0.392745 6.99325 0.343411 7.779 0.863665 8.16183L2.3799 9.27754C2.53722 9.39333 2.62995 9.57587 2.62995 9.76991V9.81583C2.62995 9.95708 2.78405 10.0457 2.90805 9.97575L4.47601 9.09137C5.04008 8.7732 5.08632 7.98575 4.56328 7.60508L2.97184 6.44683C2.64512 6.20904 2.67376 5.71725 3.02592 5.51816L4.47888 4.69679C5.04211 4.37837 5.08817 3.59195 4.56591 3.21129L3.04501 2.10273C2.88636 1.98709 2.7927 1.80372 2.7927 1.60873V1.57105C2.7927 1.43008 2.6391 1.34143 2.51511 1.41085Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15840_96400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 10,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKelpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kelp-icon.35086d9c08dff2b928ab228f427a622d.svg";